import * as runtime from '../runtime';
import { IInstruction } from '@/requests/mainApi/models/IInstruction';

export class InstructionsApi extends runtime.BaseAPI {

  async getInstructionsRaw(): Promise<runtime.ApiResponse<IInstruction[]>> {

    const headerParameters: runtime.HTTPHeaders = {};

    const queryParameters: runtime.HTTPQuery = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-App-Version"] = this.configuration.apiKey("X-App-Version"); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Id"] = this.configuration.apiKey("X-Device-Id"); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Device-Type"] = this.configuration.apiKey("X-Device-Type"); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["X-Os-Version"] = this.configuration.apiKey("X-Os-Version"); // OsVersion authentication
    }

    const response = await this.request({
      path: `/documents/v1/documents/list`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters
    });

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue);
  }

  async getInstructions(): Promise<IInstruction[]> {
    const response = await this.getInstructionsRaw();
    return await response.value();
  }
}